import {
  FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS,
  FETCH_SALES_ORDER_SUGGESTIONS_FAILURE,
  FETCH_SALES_ORDER_SUGGESTIONS,
  FETCH_PURCHASE_ORDER_SUGGESTIONS,
  FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS,
  FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE,
  FETCH_PRODUCT_SUGGESTIONS,
  FETCH_PRODUCT_SUGGESTIONS_SUCCESS,
  FETCH_PRODUCT_SUGGESTIONS_FAILURE,
} from '../actions/type';

const INITIAL_STATE = {
  salesOrderSuggestions: [],
  salesOrderSuggestionsIsLoading: false,
  salesOrderSuggestionsError: null,

  purchaseOrderSuggestions: [],
  purchaseOrderSuggestionsIsLoading: false,
  purchaseOrderSuggestionsError: null,

  productSuggestions: [],
  productSuggestionsIsLoading: false,
  productSuggestionsError: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_SALES_ORDER_SUGGESTIONS:
      return {
        ...state, salesOrderSuggestionsIsLoading: true, salesOrderSuggestions: [], salesOrderSuggestionsError: null,
      };
    case FETCH_SALES_ORDER_SUGGESTIONS_SUCCESS:
      console.log('payload: ', action.payload.data);
      return { ...state, salesOrderSuggestionsIsLoading: false, salesOrderSuggestions: action.payload.data };
    case FETCH_SALES_ORDER_SUGGESTIONS_FAILURE:
      return { ...state, salesOrderSuggestionsIsLoading: false, salesOrderSuggestionsError: action.payload.data };

    case FETCH_PURCHASE_ORDER_SUGGESTIONS:
      return {
        ...state, purchaseOrderSuggestionsIsLoading: true, purchaseOrderSuggestions: [], purchaseOrderSuggestionsError: null,
      };
    case FETCH_PURCHASE_ORDER_SUGGESTIONS_SUCCESS:
      return { ...state, purchaseOrderSuggestionsIsLoading: false, purchaseOrderSuggestions: action.payload.data };
    case FETCH_PURCHASE_ORDER_SUGGESTIONS_FAILURE:
      return { ...state, purchaseOrderSuggestionsIsLoading: false, purchaseOrderSuggestions: action.payload.data };

    case FETCH_PRODUCT_SUGGESTIONS:
      return {
        ...state, productSuggestionsIsLoading: true, productSuggestions: [], productSuggestionsError: null,
      };
    case FETCH_PRODUCT_SUGGESTIONS_SUCCESS:
      return { ...state, productSuggestionsIsLoading: false, productSuggestions: action.payload.data };
    case FETCH_PRODUCT_SUGGESTIONS_FAILURE:
      return { ...state, productSuggestionsIsLoading: false, productSuggestionsError: action.payload.data };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/autoSuggest_reducer.js